export default {
  All: 'all',
  Open: 'open',
  Committed: 'committed',
}
